// @LTG-ID: contact-sending
// @STATUS: BUILT
// @HERMETIC: true
// @DOCS: source `Contact.html` lines 1067-1096 (v4),
//        ADR-024 Amendment A (planeFly timings)
// @CHANGED: 2026-05 session_006 (CHG-0083-M-A2)
// @OWNER: web
//
// CHG-0083-M-A2 — Sending screen.
//
// Replaces the form area between Submit-click and the 201/error response.
// Renders the v4 paper-plane SVG with planeFly 1.8s motion.
//
// A.3 #5: v4 source copy is "Sending to the team..." (italic serif).
// ORCH-0087 point 3 explicit override → "Sending your message…".
// Following ORCH-0087 (orchestrator-explicit copy override).
//
// A.3 #6: v4 source has no "Reference: <key>" line on Sending. ORCH-0087
// point 3 adds it. Building per orchestrator extension.
//
// Motion contract per ADR-024 Amendment A:
//   CONTACT_PLANE_FLY_DURATION_MS = 1800 ms
// The duration is sourced from the v4 README §"All animations" line 168.
// Defined inline per ADR-024 Amendment A §"Implementation contract" item 1.

const CONTACT_PLANE_FLY_DURATION_MS = 1800;

export const Sending = ({ referenceKey }) => {
    return (
        <section
            className="ltgc-step ltgc-step-sending"
            data-testid="contact-sending"
            role="status"
            aria-live="polite"
            aria-busy="true"
            aria-label="Sending your message"
        >
            <div className="ltgc-sending-screen">
                <svg
                    className="ltgc-paper-plane-svg"
                    viewBox="0 0 140 140"
                    aria-hidden="true"
                    style={{
                        animationDuration: `${CONTACT_PLANE_FLY_DURATION_MS}ms`,
                    }}
                >
                    <defs>
                        <linearGradient
                            id="ltgc-plane-grad"
                            x1="0"
                            y1="0"
                            x2="1"
                            y2="1"
                        >
                            <stop offset="0%" stopColor="#18B0BD" />
                            <stop offset="100%" stopColor="#0A2A5E" />
                        </linearGradient>
                    </defs>
                    <g transform="translate(70, 70)">
                        <path
                            d="M -36 -8 L 38 -2 L 36 14 L 8 22 L 0 14 Z"
                            fill="url(#ltgc-plane-grad)"
                        />
                        <path
                            d="M -36 -8 L 8 22 L 0 14 Z"
                            fill="#0A2A5E"
                            opacity="0.7"
                        />
                        <path
                            d="M 38 -2 L 8 22 L 36 14 Z"
                            fill="#20C7D6"
                        />
                    </g>
                </svg>
                <p
                    className="ltgc-sending-line"
                    data-testid="contact-sending-line"
                >
                    Sending your message…
                </p>
                {referenceKey && (
                    <p
                        className="ltgc-sending-ref"
                        data-testid="contact-sending-ref"
                    >
                        Reference: <span>{referenceKey}</span>
                    </p>
                )}
            </div>
        </section>
    );
};

export default Sending;
